import { Button, Form, Input, Modal, Select, Space, Drawer, Tooltip } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { connect } from "react-redux";
import { AppState } from "src/store";
import style from './Tables.module.scss'
import { useEffect, useState } from "react";
import { getAllTagTable, getTagById, postRegisterTag, putUpdateTag } from 'src/store/tag/thunks';
import { SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined } from '@ant-design/icons';
import { SizeType } from "antd/es/config-provider/SizeContext";
import validateMessages from "src/globals/Inputs/validateMessages";
import TextArea from "antd/es/input/TextArea";
import form from "antd/es/form";
import { NamePath } from "antd/es/form/interface";
import { Tag } from 'src/store/tag/types';
import { validate1, validate150, validateNumber } from "src/globals/Inputs/validateInput";
import { getUserByToken } from "src/store/user/thunks";
import { getTypeOrganization, postRegisterTypeOrganization, putTypeOrganization } from "src/store/organization/thunks";


interface TableProps {
    postRegisterTypeOrganization?: any;
    putTypeOrganization?: any;
    getTypeOrganization?: any;
}
interface DataType {
    key: string;
    id: string;
    name: string;
    created_at: string;
    updated_at: string;
}

type DataIndex = keyof DataType;
type RequiredMark = boolean | 'optional';
const TTypeOrganization: React.FC<TableProps> = (props: TableProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [typeModal, setTypeModal] = useState(true);
    const [idTag, setIdTag] = useState('');
    const [formValidate] = Form.useForm();
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const [isRol, setIsRol] = useState('');
    const { Option } = Select;
    //LLamar al EndPoint tanto en el Iterface como en el Map, 
    const init = async () => {

        const responseDataTag = await props.getTypeOrganization();
        setDataTable(responseDataTag);
    }
    useEffect(() => {
        init();
    }, []);

    //Crear una tabla.
    const [dataTable, setDataTable] = useState([]);

    const columns: ColumnsType<DataType> = [
        {
            title: '',
            width: 0,
            dataIndex: 'id',
            key: 'id',
            render: () => null,
        },
        {
            title: 'Nombre',
            width: 25,
            dataIndex: 'name',
            key: 'name',

        },
        {
            title: 'Fecha de creación',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 15,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },

        },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 3,

            render: (record: DataType) =>
                <Space size="middle"> 

                    <Tooltip placement="topRight" title={validateMessages.updateButton} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => handleTypeOpenModelUpdate(record)}
                            icon={<EditOutlined />}
                        />

                    </Tooltip>

                </Space>
        },

    ];


    const handleCancel = () => {
        formValidate.resetFields();
        setIsModalOpen(false)
    };
    const handleTypeOpenModel = () => {
        setIsModalOpen(true)
        setTypeModal(true)
    };
    const handleTypeOpenModelUpdate = async (value: DataType) => {
        setIsModalOpen(true)
        setTypeModal(false)
        formValidate.setFieldsValue({
            name: value.name, id: value.id
        });
    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const onFinish = async (values: any) => {
        if (!typeModal) {
            const Source = {
                id: values.id,
                name: values.name,
            };
            await props.putTypeOrganization(Source);
        } else {
            const Source = {
                name: values.name,
            };
            await props.postRegisterTypeOrganization(Source);
        }
        handleCancel();
        const responseData = await props.getTypeOrganization();
        setDataTable(responseData);
        formValidate.resetFields();
    };

    return (
        <>
            <Button
                type="primary"
                icon={<PlusCircleOutlined />}
                className={style["create-button-user"]}
                onClick={handleTypeOpenModel}
            >
                Crear Tipo
            </Button>
            <Table size="small" columns={columns} dataSource={dataTable} scroll={{ x: 1500 }} />
            <Drawer title={typeModal ? "Crear Tipo" : "Actualizar Tipo"} open={isModalOpen} onClose={handleCancel} width={350} footer={null}>
                <Form
                    form={formValidate}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item style={{ display: 'none' }} name="id">
                        <Input />
                    </Form.Item>

                    <Form.Item label="Nombre" name="name" rules={[
                        //para mantener el formato de los mensajes de informacion o error
                        { required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) },
                    ]}>
                        <Input placeholder="Ingresar nombre" />
                    </Form.Item>

                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            {typeModal ? "Ingresar" : "Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
        </>


    );


};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    postRegisterTypeOrganization, putTypeOrganization, getTypeOrganization
})(TTypeOrganization);